import { render, staticRenderFns } from "./NewPlanItem.vue?vue&type=template&id=77e4c028&"
import script from "./NewPlanItem.vue?vue&type=script&lang=js&"
export * from "./NewPlanItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports